import apistatementReport from "./statementReportApi";
import { reportDownloaded, reportDownloading, reportError, reportInit } from "./statementReportStateActions";
import { FileResponse } from "../../../types/types";
export function downloadStatement(dispatch: any, customerAccountId: number, statementRunEntryNo: number) {
  dispatch(reportDownloading(statementRunEntryNo));
  apistatementReport.getStatementReport(customerAccountId, statementRunEntryNo).then(
    function (value: FileResponse | null) {
      if (value && value.status === 200) {
        dispatch(reportDownloaded(value.data));
      } else {
        dispatch(reportError("Error occurred while downloading statement"));
      }
    },
    function (error: any) {
      dispatch(reportError("Error occurred while downloading statement"));
    }
  );
}
export function downloadMaguireStatement(
  dispatch: any,
  customerAccountId: number,
  statementId: number,
  billingCycleId: number
) {
  dispatch(reportDownloading(billingCycleId));
  apistatementReport.getMaguireStatementReport(customerAccountId, statementId, billingCycleId).then(
    function (value: FileResponse | null) {
      if (value && value.status === 200) {
        dispatch(reportDownloaded(value.data));
      } else {
        dispatch(reportError("Error occurred while downloading statement"));
      }
    },
    function (error: any) {
      dispatch(reportError("Error occurred while downloading statement"));
    }
  );
}

export function initReport(dispatch: any) {
  dispatch(reportInit());
}
